module.exports = __webpack_public_path__ + "static/img/platform-logo.d240b523.png";